import {IUsedResources} from '../models/cleanUp';
import {useCleanUpResources} from './useCleanUpResources';
import {useResources} from '../store/resource/resource';

export const useAggregateResources = (used_general_resources: IUsedResources[]) => {
    const [generalResources] = useResources();

    const aggregatedResources = used_general_resources.reduce((acc: IUsedResources[], val) => {
        const index = acc.findIndex((obj) => obj.resource === val.resource);
        const isShared =
            generalResources.find((r) => r.id === val.resource)?.is_shared ?? false;

        if (index !== -1) {
            if (isShared) {
                acc[index].amount = Math.max(acc[index].amount, val.amount);
            } else {
                acc[index].amount += val.amount;
            }
        } else {
            acc.push({
                resource: val.resource,
                amount: val.amount,
            });
        }

        return acc;
    }, []);

    return useCleanUpResources(aggregatedResources);
};
